<template>
    <div class="bid-form">
        <h4 class="text-left kova-text font-weight-bolder mt-5 placement">Place Bid</h4>
        <div class="text-left">
            <a-icon type="exclamation-circle" class="icon-size" />
            <span class="ml-3">You will be able to edit your bid till you are awarded the project</span>
        </div>

        <h4 class="text-left mt-4">Cover Letter</h4>
        <vue-editor
            useCustomImageHandler
            id="cover_letter"
            v-model="cover_letter"
            placeholder="Why are you a good fit for this project..."
            @image-added="handleImageAdded"
        ></vue-editor>

        <div class="row" v-if="milestones.length">
            <div class="col-12 col-md-6 pl-1 pr-1">
                <h5 class="text-left mt-4 ml-3">Bill Amount</h5>
                <a-input-group compact>
                    <a-input
                        type="number"
                        size="large"
                        class="text-left"
                        style="width: 70%"
                        :min="0"
                        :value="total_amount"
                        disabled
                    />
                    <a-select size="large" class="text-left" disabled :defaultValue="currency">
                        <a-select-option value="USD">USD</a-select-option>
                        <a-select-option value="Naira">Naira</a-select-option>
                        <a-select-option value="EUR">EUR</a-select-option>
                    </a-select>
                </a-input-group>
            </div>
            <div class="col-12 col-md-6 pr-1 pl-1">
                <h5 class="text-left mt-4 ml-3">Delivery Timeline</h5>
                <a-input-group compact>
                    <a-input
                        size="large"
                        class="text-left"
                        id="delivery_time"
                        disabled
                        :value="duration"
                        style="width: 70%"
                        placeholder="7"
                        type="number"
                    />
                    <a-select size="large" class="text-left" v-model="timeline" disabled defaultValue="Days">
                        <a-select-option value="Days">Days</a-select-option>
                        <a-select-option value="Weeks">Weeks</a-select-option>
                        <a-select-option value="Months">Months</a-select-option>
                    </a-select>
                </a-input-group>
            </div>
        </div>

        <div class="pl-1">
            <h5 class="text-left mt-3">Milestones</h5>
            <p class="text-left" v-if="!milestones.length">
                Add milestones to help you break up the scope of work into smaller deliverables to track progress of the
                project. These can be viewed and modified by the client.
            </p>
        </div>

        <div class="row mt-4 pl-1 milestones" v-for="(mile, i) in milestones" :key="i">
            <!-- <h5 class="text-left ml-3">Enter a milestone</h5> -->
            <div class="text-left ml-3" style="width: 100%">
                <a-input-group compact>
                    <div class="mr-3 mt-3">
                        <p>{{ i + 1 }}.</p>
                    </div>

                    <a-input
                        size="large"
                        class="text-left mr-2"
                        id="milestone_title"
                        style="width: 50%"
                        placeholder="Enter the title of this milestone"
                        v-model="mile.title"
                        type="text"
                    />

                    <a-input
                        type="number"
                        id="milestone_amount"
                        addon-before="$"
                        :min="Number(rate[0])"
                        class="text-left"
                        style="width: 17%"
                        size="large"
                        :max="Number(rate[1])"
                        :placeholder="`${Number(rate[0]) + Number(rate[1]) / 2}`"
                        v-model.number="mile.amount"
                        @change="calculateDuration(i, mile.due_date)"
                        addon-after="/hr"
                    />

                    <a-input
                        type="number"
                        id="milestone_hours"
                        :min="1"
                        class="text-left ml-2"
                        style="width: 16%"
                        size="large"
                        :max="40"
                        placeholder=""
                        v-model.number="mile.hours"
                        @change="calculateDuration(i, mile.due_date)"
                        addon-after="hours"
                    />
                    <a-icon class="close mt-2" @click="remove(i)" type="close-circle" color="#FC0404" />
                </a-input-group>
            </div>
            <a-textarea
                id="milestone_details"
                class="p-3 mx-3 mt-3"
                v-model="mile.details"
                placeholder="Write the details about this milestone..."
                :rows="4"
            />

            <div class="text-left mb-3 ml-3" id="milestone_deadline">
                Deadline: {{ mile.due_date }}
                <a-icon class="ml-1" type="edit" @click="selectDate(i)" />
                <a-date-picker
                    class="date-pick"
                    @change="onDatePick($event, i)"
                    :id="`dateSelect` + i"
                    :disabled-date="disabledDate"
                />
            </div>
            {{ mile }}
            <hr />
        </div>

        <div class="text-right">
            <a-button size="large" class="bg-light ant-btn ant-btn-lg mr-1" @click="add"
                >add more
                <a-icon type="plus" style="position: relative; bottom: 3px;" />
            </a-button>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import { VueEditor } from 'vue2-editor';
import { levels } from '../../data/resources';

export default {
    components: {
        VueEditor,
    },
    name: 'bid-form',
    props: {
        currency: {
            type: String,
            default: 'USD',
        },
        profileData: Object,
    },
    data: () => ({
        calendar: {},
        showCalender: false,
        milestones: [],
        cover_letter: '',
        timeline: 'Days',
        moment,
        total_amount: 0,
        duration: 0,
    }),
    computed: {
        workrate() {
            if (this.data.HourRate && !this.$route.path.includes('settings')) {
                return `Hourly Rate: $${this.data.HourRate}`;
            }

            return levels.find(key => key.id == this.profileData.WorkRate)?.work_rate;
        },
        rate() {
            // return this.workrate.replace(/\$/g, '').replace(/ /g, '').split('-')
            return [10, 45];
        },
    },
    methods: {
        handleImageAdded: function(file, Editor, cursorLocation, resetUploader) {
            var formData = new FormData();
            formData.append('file', file);

            this.$http({
                url: 'https://fakeapi.yoursite.com/images',
                method: 'POST',
                data: formData,
            }).then(result => {
                let url = result.data.url; // Get url from response
                Editor.insertEmbed(cursorLocation, 'file', url);
                resetUploader();
            });
            // .catch(err => {
            // console.log(err);
            // });
        },
        getTimeline() {
            const { duration, timeline } = this;

            const delivery_time =
                timeline == 'Weeks' ? duration * 7 : timeline == 'Months' ? duration * 30 : Number(duration);
            this.$emit('bidding', { delivery_time });
        },
        add() {
            const due_date = this.dateFormat(moment.now());
            const len = this.milestones.length;
            // const new_date = moment.now().add(len, 'days');
            // console.log(new_date);

            this.milestones.push({
                title: '',
                amount: 0,
                due_date,
                details: '',
                total_amount: 0,
                hours: 0,
            });

            this.calculateDuration(len - 1, due_date);
        },
        remove(index) {
            this.milestones.splice(index, 1);
        },
        disabledDate(current) {
            return current < moment().endOf('day');
        },
        selectDate(i) {
            document.querySelector('#dateSelect' + i + ' .ant-calendar-picker-input.ant-input').click();
        },
        dateFormat: value => moment(value).format('LL'),
        onDatePick(value, index) {
            let date = this.dateFormat(value._d);
            this.milestones[index].due_date = date;
            this.$forceUpdate();

            this.calculateDuration(index, date);
        },
        calculateDuration(index, date) {
            if (!index || !date) return;
            let prevDate =
                index > 0 ? this.dateFormat(this.milestones[index - 1].due_date) : this.dateFormat(moment.now());
            const duration = moment.duration(moment(date).diff(prevDate));

            this.milestones[index].total_amount =
                Math.round(duration.asDays()) *
                (this.milestones[index].amount || 0) *
                (this.milestones[index].hours || 0);
            this.$forceUpdate();
            this.milestones[index].duration = Math.round(duration.asDays());
            this.$forceUpdate();
        },
    },
    watch: {
        milestones: {
            handler() {
                const { milestones } = this;

                const total_amount = milestones.map(key => key.total_amount).reduce((a, b) => a + b, 0);
                this.total_amount = total_amount;

                const duration = this.milestones.map(key => key.duration).reduce((a, b) => a + b, 0);
                this.duration = duration;

                this.$emit('bidding', { milestones });
            },
            deep: true,
        },
        cover_letter() {
            const { cover_letter } = this;
            this.$emit('bidding', { cover_letter });
        },
    },
};
</script>

<style scoped>
.date-pick {
    visibility: hidden;
}

.close {
    font-size: 18px;
    position: absolute;
    right: 20px;
    color: #fc0404;
}

#milestone_deadline {
    width: 40%;
    height: 30px;
}

#cover_letter {
    text-align: left;
}
</style>
